import React from 'react';
import TourMenuPicker from '../TourMenuPicker/TourMenuPicker.react';
import './TourMenuWeb.less';

class TourMenuWeb extends React.Component {
    render() {
        return (
            <div className={'TourMenuWeb'}>
                <TourMenuPicker {...this.props} />
            </div>
        );
    }
}

export default TourMenuWeb;
